var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" GreenGeeks SSL Auto-Installer ")]),
      _c(
        "gg-card-text",
        [
          [
            _c(
              "div",
              {
                staticClass: "text-center"
              },
              [_c("p", [_vm._v(_vm._s(_vm.currentstep))])]
            ),
            _vm.currentstepdetail
              ? _c(
                  "div",
                  {
                    staticClass: "text-center"
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "text-center pt-4",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [_c("p", [_vm._v(_vm._s(_vm.currentstepdetail))])]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.ssl_error
              ? _c(
                  "div",
                  {
                    staticClass: "text-center"
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "text-center pt-4",
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "strong",
                          {
                            staticClass: "error--text"
                          },
                          [_vm._v(_vm._s(_vm.ssl_error))]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.canInstall
              ? _c(
                  "div",
                  {
                    staticClass: "text-center"
                  },
                  [
                    _c(
                      "gg-btn",
                      {
                        staticClass: "justify-center",
                        on: {
                          click: _vm.nextstep
                        }
                      },
                      [_vm._v("Install SSL Certificate")]
                    )
                  ],
                  1
                )
              : _c(
                  "v-container",
                  {
                    staticClass: "py-0 px-0"
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showProgress,
                                expression: "showProgress"
                              }
                            ],
                            attrs: {
                              cols: "12",
                              sm: "10",
                              "offset-sm": "1"
                            }
                          },
                          [
                            _c("v-progress-linear", {
                              attrs: {
                                color: "green",
                                value: _vm.installProgress
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }